<template>
  <v-container
      class="fill-height"
      fluid
  >
    <v-row
        align="center"
        justify="center"
    >
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-toolbar
              color="primary"
              dark
              flat
          >
            <v-toolbar-title>Amazon Assistant</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" :value="valid" lazy-validation>
              <v-text-field
                  label="账号"
                  prepend-icon="mdi-account"
                  type="text"
                  v-model="name"
                  :rules="nameRules"
                  :counter="16"
              ></v-text-field>

              <v-text-field
                  id="password"
                  label="密码"
                  prepend-icon="mdi-lock"
                  type="password"
                  v-model="password"
                  :rules="passwordRules"
                  :counter="16"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="login">登录</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      valid: false,
      name: null,
      nameRules: [
          v => !!v || "请输入账号",
          v => v && v.length >= 2 && v.length <= 16 || "账号长度只能2-16位."
      ],
      password: null,
      passwordRules: [
          v => !!v || "请输入密码",
          v => v && v.length >= 6 && v.length <= 16 || "密码长度只能6-16位."
      ]
    }
  },
  methods: {
    login() {
      if (this.$refs.form.validate()) {
        let params = new URLSearchParams();
        params.append("name", this.name.toLowerCase());
        params.append("password", this.password);
        this.$axios.post("/login", params)
        .then(
            response => {
              localStorage.name = this.name;
              localStorage.token = response.data;
              this.$router.push("/home/quotation/search").catch(()=>{});
            }
        );
      }
    }
  }
}
</script>

<style scoped>

</style>